import { create } from 'zustand';
import { AdvertiserOwnerOptionsQueryUsers } from 'wb-reddit/graphql/generated';
import { User } from 'wb-spotify/graphql/authgraph/generated';
import { AdvertiserRow } from 'wb-reddit/app/routes/advertisers/container';
import { ProfileImage } from 'wb-reddit/app/common/components/profileImageUploader';

export type MutatingAdvertiser = AdvertiserRow & {
	agencyAccountProfilePicture?: ProfileImage | null | string
	agencyAccountOwner?: AdvertiserOwnerOptionsQueryUsers | null
	owner?: User | null
};

export type MutatingNewAdvertiser = MutatingAdvertiser & {
	agencyAccountProfilePicture?: ProfileImage
};

export const newAdvertiser: MutatingNewAdvertiser = {
	agencyAccountName: '',
	users:             [],
	userGroups:        [],
	id:                '',
	agencyAccountId:   '',
};

type RedditAdvertiserMutatorState = {
	loading?: boolean;
	setLoading: (loading?: boolean) => void;
	mutatingAdvertiser?: MutatingAdvertiser;
	setMutatingAdvertiser: (mutatingAdvertiser?: MutatingAdvertiser) => void;
};

// TODO check mutation function, executes multiple times when open edit page
const useRedditAdvertiserMutator = create<RedditAdvertiserMutatorState>((set) => ({
	loading:               false,
	setLoading:            (loading) => set({ loading }),
	mutatingAdvertiser:    undefined,
	setMutatingAdvertiser: (mutatingAdvertiser) => set({ mutatingAdvertiser }),
}));

export default useRedditAdvertiserMutator;
